const SPLIT_REGX = /(<a.*>.*?<\/a>)/gim;
const URL_REGX =
  /(?<schema>https?:\/\/)?(?<additionalDomain>[\da-zа-яё.-]+\.)?(?<secondDomain>[\da-zа-яё-]{1,63}\.)(?<firstDomain>[a-zа-яё]{2,8})(?<slug>\/?[^\s\?]*)?(?<params>\?\S*)?/gim;

const EMAIL_REGX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}[.,:!?)-]?$/;

const HTTP = "http";

const isExternalURL = (url: string) => {
  try {
    return new URL(url).origin !== location.origin;
  } catch {
    return false;
  }
};

const replaceCb = (url: string) => {
  const href = url.startsWith(HTTP) ? url : `${HTTP}://${url}`;
  const sanitizedHref = href.replace(/[.,]+$/i, "");
  const trailingChar = href.slice(sanitizedHref.length);

  const anchorTag = isExternalURL(sanitizedHref)
    ? `<a target='_blank' rel="noopener noreferrer" href='${sanitizedHref}'>${sanitizedHref}</a>`
    : `<a href='${sanitizedHref}'>${sanitizedHref}</a>`;

  return `${anchorTag}${trailingChar}`;
};

export const linkInText = (text: string) => {
  try {
    const splitText = text.split(SPLIT_REGX);

    const result = splitText
      .map((item) =>
        SPLIT_REGX.test(item)
          ? item
          : item
              .split(/(\s)/g)
              .map((word) => {
                if (EMAIL_REGX.test(word)) {
                  return word;
                }

                return word.replace(URL_REGX, replaceCb);
              })
              .join("")
      )
      .join("");

    return result;
  } catch {
    return text;
  }
};
